import React from 'react';
import ContentLoader from 'react-content-loader';

const ClientAddLoader = () => {
  return (
    <ContentLoader
      speed={2}
      width={1463}
      height={950}
      viewBox="0 0 1463 950"
      backgroundColor='#f3f3f3'
      foregroundColor='#ecebeb'>
      <>
        <rect x="28" y="26" rx="3" ry="3" width="176" height="12" />
        <rect x="28" y="53" rx="3" ry="3" width="89" height="8" />
        <rect x="28" y="75" rx="3" ry="3" width="250" height="30" />
        <rect x="28" y="138" rx="3" ry="3" width="48" height="8" />
        <circle cx="35" cy="162" r="7" />
        <circle cx="35" cy="185" r="7" />
        <rect x="50" y="159" rx="3" ry="3" width="89" height="8" />
        <rect x="50" y="179" rx="3" ry="3" width="89" height="8" />
        <rect x="28" y="213" rx="3" ry="3" width="150" height="7" />
        <rect x="28" y="233" rx="3" ry="3" width="250" height="30" />
        <rect x="28" y="290" rx="3" ry="3" width="89" height="8" />
        <rect x="28" y="307" rx="3" ry="3" width="250" height="30" />
        <rect x="28" y="365" rx="3" ry="3" width="89" height="8" />
        <rect x="28" y="387" rx="4" ry="4" width="299" height="30" />
        <rect x="28" y="435" rx="3" ry="3" width="89" height="8" />
        <rect x="28" y="456" rx="3" ry="3" width="414" height="90" />
        <rect x="28" y="574" rx="3" ry="3" width="89" height="8" />
        <rect x="28" y="592" rx="3" ry="3" width="120" height="8" />
        <rect x="28" y="610" rx="3" ry="3" width="250" height="30" />
        <rect x="28" y="681" rx="3" ry="3" width="327" height="8" />
        <rect x="28" y="763" rx="3" ry="3" width="148" height="30" />
        <rect x="205" y="765" rx="3" ry="3" width="105" height="30" />

        <rect x="294" y="56" rx="3" ry="3" width="89" height="8" />
        <rect x="293" y="76" rx="3" ry="3" width="250" height="30" />
        <rect x="564" y="57" rx="3" ry="3" width="89" height="8" />
        <rect x="563" y="75" rx="3" ry="3" width="163" height="30" />
        <rect x="335" y="321" rx="3" ry="3" width="150" height="7" />
        <rect x="300" y="318" rx="3" ry="3" width="16" height="16" />
        <rect x="350" y="365" rx="3" ry="3" width="89" height="8" />
        <rect x="350" y="387" rx="5" ry="5" width="122" height="30" />
        <rect x="492" y="365" rx="3" ry="3" width="89" height="8" />
        <rect x="492" y="387" rx="3" ry="3" width="157" height="30" />
        <rect x="35" y="701" rx="3" ry="3" width="250" height="30" />
      </>
    </ContentLoader>
  );
};

export default ClientAddLoader;
